export default {"src":"/_next/static/media/logo_main-nav.131579b9.svg","height":32,"width":134,"blurWidth":0,"blurHeight":0};